 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"answer": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"answer": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "build-assets/js/" + ({}[chunkId]||chunkId) + "." + {"chunk-047f5df2":"3a9aad99","chunk-01082727":"96cd11b0","chunk-10705fe0":"860e383c","chunk-2aa25ec7":"9e3d561e","chunk-4a47bb3a":"5da6d1a6","chunk-133d6ef2":"26e14637","chunk-aea61848":"73cfd2f0","chunk-4dbe0fb8":"d1b73dc3","chunk-62ed9df3":"c1bfc9a6","chunk-56a31f36":"b4caebd5","chunk-10da8bde":"d8b26a0c","chunk-5ec8f22e":"45c17f97","chunk-5febc282":"b5de6f9c","chunk-6240d3f3":"13a4d7c9","chunk-6366f172":"af44839a","chunk-76fb16c8":"49c18126","chunk-c966612e":"7603b36c","chunk-0f823d92":"9db5e1bb","chunk-13d5d8ce":"e6d27f2d","chunk-20586868":"249726ac","chunk-2348df90":"a8ee50a8","chunk-28e8aa92":"7e54a455","chunk-2de1c7b0":"7293e227","chunk-33cd8ffe":"a914eba9","chunk-37c81532":"b6b44392","chunk-3ca9a316":"1b01e20d","chunk-3ebe295c":"68dbdc0d","chunk-40c536f7":"05cdf63d","chunk-411aba06":"22ec5341","chunk-47e206a9":"f7f57eb2","chunk-49e49c46":"dbd2f84a","chunk-55c8a9a0":"61da5a54","chunk-49133a30":"f6b8cdea","chunk-575cc4fc":"cac8c2ad","chunk-5806cfd7":"394b5139","chunk-5d48b5be":"e4374501","chunk-64681390":"87075226","chunk-7b17cac1":"f44c5b64","chunk-7e077d28":"0529eee8","chunk-7f23c720":"3236cc26","chunk-882b541c":"fb51ac71","chunk-a961d782":"7733bbc7","chunk-c0e9ac88":"edfcbf04","chunk-c351a7fe":"744538c4","chunk-c385ff0a":"515f4f00","chunk-c99394c8":"d95dd0c9","chunk-e9817fae":"6f3090aa","chunk-ecdd0a64":"c8a1667f","chunk-f57a4726":"b2c9c959"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-047f5df2":1,"chunk-01082727":1,"chunk-10705fe0":1,"chunk-2aa25ec7":1,"chunk-4a47bb3a":1,"chunk-133d6ef2":1,"chunk-aea61848":1,"chunk-4dbe0fb8":1,"chunk-62ed9df3":1,"chunk-56a31f36":1,"chunk-10da8bde":1,"chunk-5ec8f22e":1,"chunk-5febc282":1,"chunk-6240d3f3":1,"chunk-6366f172":1,"chunk-76fb16c8":1,"chunk-c966612e":1,"chunk-0f823d92":1,"chunk-13d5d8ce":1,"chunk-20586868":1,"chunk-2348df90":1,"chunk-28e8aa92":1,"chunk-2de1c7b0":1,"chunk-33cd8ffe":1,"chunk-37c81532":1,"chunk-3ca9a316":1,"chunk-3ebe295c":1,"chunk-40c536f7":1,"chunk-411aba06":1,"chunk-47e206a9":1,"chunk-49e49c46":1,"chunk-55c8a9a0":1,"chunk-49133a30":1,"chunk-575cc4fc":1,"chunk-5806cfd7":1,"chunk-5d48b5be":1,"chunk-64681390":1,"chunk-7b17cac1":1,"chunk-7e077d28":1,"chunk-7f23c720":1,"chunk-882b541c":1,"chunk-a961d782":1,"chunk-c0e9ac88":1,"chunk-c351a7fe":1,"chunk-c385ff0a":1,"chunk-c99394c8":1,"chunk-e9817fae":1,"chunk-ecdd0a64":1,"chunk-f57a4726":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "build-assets/css/" + ({}[chunkId]||chunkId) + "." + {"chunk-047f5df2":"2591cea8","chunk-01082727":"f10b809c","chunk-10705fe0":"be1638fc","chunk-2aa25ec7":"3d0d689c","chunk-4a47bb3a":"552eb635","chunk-133d6ef2":"2b0b26f3","chunk-aea61848":"329a70f6","chunk-4dbe0fb8":"8cbc7dd0","chunk-62ed9df3":"32997caa","chunk-56a31f36":"a18f04ac","chunk-10da8bde":"2c43216f","chunk-5ec8f22e":"247ffdd9","chunk-5febc282":"02004250","chunk-6240d3f3":"039fddfb","chunk-6366f172":"15d9571a","chunk-76fb16c8":"143bb6ab","chunk-c966612e":"9c3ae7dc","chunk-0f823d92":"2ba75c59","chunk-13d5d8ce":"5e309091","chunk-20586868":"fe89023a","chunk-2348df90":"e37d8f18","chunk-28e8aa92":"d03278fb","chunk-2de1c7b0":"ecb2ed49","chunk-33cd8ffe":"68f5dcba","chunk-37c81532":"373e7105","chunk-3ca9a316":"00af3092","chunk-3ebe295c":"ef93bc3e","chunk-40c536f7":"3691069f","chunk-411aba06":"cbff7f59","chunk-47e206a9":"cbff7f59","chunk-49e49c46":"04eac7f3","chunk-55c8a9a0":"ee95603a","chunk-49133a30":"5a076218","chunk-575cc4fc":"6614c254","chunk-5806cfd7":"896d26d7","chunk-5d48b5be":"4567ab5b","chunk-64681390":"bdd7c988","chunk-7b17cac1":"660816e1","chunk-7e077d28":"20ca0189","chunk-7f23c720":"bf5ac0da","chunk-882b541c":"72abba14","chunk-a961d782":"1de6b6e7","chunk-c0e9ac88":"1b1fb999","chunk-c351a7fe":"34a41c85","chunk-c385ff0a":"764eee13","chunk-c99394c8":"cbff7f59","chunk-e9817fae":"e1b5c3df","chunk-ecdd0a64":"4866328d","chunk-f57a4726":"03af2210"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
